module.exports = __webpack_public_path__ + "img/icon_trophy.170d8aa9.svg";